import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-store';
import { UserIdleService } from 'angular-user-idle';
import { RemoteService } from 'app/services/remote.service';
import { MatDialog } from '@angular/material/dialog';
import { JwtHelperService } from "@auth0/angular-jwt";
import { FormGroup, FormBuilder } from '@angular/forms';
import { SessionConfirmationModalComponent, ConfirmDialogModel } from './session-confirmation-modal/session-confirmation-modal.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  chat: FormGroup
  showChat: boolean = false;
  chatArray = [];
  helper = new JwtHelperService();
  selectedValue: any;
  disableInput: boolean = false;
  showSendText: boolean;
  constructor(public localStorage: LocalStorageService,
    public router: Router, private userIdle: UserIdleService,
    private remoteService: RemoteService, public dialog: MatDialog,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.chat = this.fb.group({
      message: ['']
    })
    this.userIdle.setConfigValues({ idle: 600, timeout: 60, ping: 12 })
    this.userIdle.startWatching();
    this.userIdle.onTimerStart().subscribe(count => this.idleEvent(count));
    this.userIdle.onTimeout().subscribe(() => this.timeOutEvent());
    this.remoteService.getAccesTokenInterval();
  }

  timeOutEvent() {
    if (this.helper.isTokenExpired(this.localStorage.get('access_token')) === false) {
      this.logout1();
    } else {
      this.router.navigate(['/login']);
      this.localStorage.clear();
    }
    this.userIdle.resetTimer();
  }

  idleEvent(count) {
    if (count == 1) {
      if (this.localStorage.get('tokenDetails')) {
        if (this.remoteService.sessionIsShow == false) {
          this.confirmDialog()
        }
      }
    }
  }

  logout1() {
    if (this.localStorage.get('tokenDetails')) {
      const tokenData = this.localStorage.get('tokenDetails');
      const payload = {
        access_token: tokenData.access_token,
        refresh_token: tokenData.refresh_token,
        before_policy: tokenData.before_policy,
        expires_in: tokenData.expires_in,
        refresh_expires_in: tokenData.refresh_expires_in,
        scope: tokenData.scope,
        session_state: tokenData.session_state,
        token_type: tokenData.token_type,
        user_name: this.localStorage.get('userName')
      }
      this.remoteService.logout(payload).subscribe(res => {
        this.router.navigate(['/login']);
        this.localStorage.clear();
      }, (error) => {
        this.localStorage.clear();
        this.router.navigate(['/login']);
      });
    }
  }

  confirmDialog(): void {
    this.remoteService.sessionIsShow = true;
    const data = {
      title: 'Are you still there?',
      body: 'You will be timeout in few seconds',
      isShow: true,
      buttonName: 'Stay'
    }
    const dialogData = new ConfirmDialogModel(data);
    const dialogRef = this.dialog.open(SessionConfirmationModalComponent, {
      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.userIdle.resetTimer();
      if (dialogResult == true) {
        if (this.helper.isTokenExpired(this.localStorage.get('access_token')) === false) {
          this.remoteService.sessionIsShow = false;
        } else {
          this.localStorage.clear();
          this.router.navigate(['/login']);
        }
      } else {
        if (this.helper.isTokenExpired(this.localStorage.get('access_token')) === false) {
          this.logout1();
        } else {
          this.localStorage.clear();
          this.router.navigate(['/login']);
        }
      }
    });
  }

  openForm() {
    this.chatArray = [];
    if (this.localStorage.get('chatData')) {
      this.showSendText = true;
      setTimeout(() => {
        this.chatArray = this.localStorage.get('chatData');
        if (this.chatArray[this.chatArray.length - 1].buttons) {
          this.disableInput = true;
        } else {
          this.disableInput = false;
        }
        this.showSendText = false;
      }, 3000);
    }
    this.showChat = !this.showChat;
    if (this.showChat === true) {
      document.getElementById("myForm").style.display = "block";
    } else {
      document.getElementById("myForm").style.display = "none";
    }
    setTimeout(() => {
      this.scrollMovetoEnd();
    }, 3001);
  }

  scrollMovetoEnd() {
    var objDiv = document.getElementById("your_div");
    objDiv.scrollTop = objDiv.scrollHeight;
  }

  closeForm() {
    this.showChat = !this.showChat;
    document.getElementById("myForm").style.display = "none";
  }

  selectOptionButton(value, i) {
    this.selectedValue = value;
    this.sendMessage(value)
    this.chatArray[i].forEach(element => {
      element.status = true;
    });
  }

  sendMessage(value1) {
    var value;
    if (value1.payload) {
      value = value1.payload
    } else {
      value = value1
    }
    const payload = {
      message: value
    }
    if ((value).trim('') === '' || value === null || value === undefined) {
      return;
    }
    if (value1.title) {
      this.chatArray.push([{ text: value1.title, key: 'user', time: new Date() }]);
    } else {
      this.chatArray.push([{ text: value1, key: 'user', time: new Date() }]);
    }
    this.showSendText = true;
    this.remoteService.isShowSpinner = false;
    setTimeout(() => {
      this.scrollMovetoEnd();
    }, 30);
    this.remoteService.sendMessage(payload).subscribe(res => {
      res.map((res1, i) => {
        if (i === 0) {
          res1.key = 'boat';
          res1.time = new Date();
          res1.isTimeStatus = true;
        } else {
          res1.key = 'boat';
          res1.time = new Date();
        }
      })
      setTimeout(() => {
        this.showSendText = false;
        this.chat.reset();
        this.chatArray.push(res);
        this.chatArray[this.chatArray.length - 1].forEach(element => {
          if (element.buttons) {
            this.disableInput = true;
          } else {
            this.disableInput = false;
          }
        });
        this.localStorage.set('chatData', this.chatArray);
      }, 3000);
      setTimeout(() => {
        this.scrollMovetoEnd();
      }, 3001);
    })
  }
}
